module.exports = __webpack_public_path__ + "img/loseblatt2.4e05a60d.jpg";